// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html[t=light] .top-banner-login{border:1px solid var(--m-theme-color-gray-600)!important}.text-input::-moz-placeholder{font-size:15px;font-weight:500}.text-input:-ms-input-placeholder{font-size:15px;font-weight:500}.text-input::placeholder{font-size:15px;font-weight:500}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
